var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "preview-ecircular" },
    [
      _c(
        "modal",
        {
          ref: "previewModal",
          attrs: {
            modalId: _vm.modalId,
            modalType: "large-modal",
            beforeCloseModal: _vm.beforeCloseModal,
          },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("div", { staticClass: "preview-ecircular__basic" }, [
              !_vm.isVendorEcircular
                ? _c("div", [
                    _c("div", { staticClass: "basic-item" }, [
                      _c("label", { staticClass: "basic-item__label" }, [
                        _vm._v(_vm._s(_vm.$t("eCircular.building")) + ":"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "basic-item__value" }, [
                        _vm._v(
                          _vm._s(
                            (_vm.currentECircular.buildings || []).join(",")
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "basic-item" }, [
                      _c("label", { staticClass: "basic-item__label" }, [
                        _vm._v(_vm._s(_vm.$t("eCircular.category")) + ":"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "basic-item__value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getDisplayCategory(
                              _vm.currentECircular.category
                            )
                          )
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "basic-item" }, [
                _c("label", { staticClass: "basic-item__label" }, [
                  _vm._v(_vm._s(_vm.$t("from")) + ":"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "basic-item__value" }, [
                  _vm._v(_vm._s(_vm.$t("eCircular.hkCircular"))),
                ]),
              ]),
              _vm._v(" "),
              _vm.previewType === _vm.PREVIEW_TYPES.SEND
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "basic-item e-circular-bcc-group",
                        attrs: { id: "eCircularBccGroup" },
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "basic-item__label",
                            attrs: { for: "e-circular-bcc" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("bcc")) +
                                ":\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            { name: "hkldinput", rawName: "v-hkldinput" },
                            { name: "autosize", rawName: "v-autosize" },
                            {
                              name: "fusioninputcheck",
                              rawName: "v-fusioninputcheck",
                              value: {
                                type: "string",
                                tip: _vm.invalidEmailTip,
                                pattern: _vm.validateEmails,
                                classes: "tooltip-class",
                                required: _vm.bccString.trim(),
                              },
                              expression:
                                "{\n                type: 'string',\n                tip: invalidEmailTip,\n                pattern: validateEmails,\n                classes: 'tooltip-class',\n                required: bccString.trim()\n              }",
                            },
                          ],
                          staticClass:
                            "autosize basic-item__value basic-item__value--input",
                          attrs: {
                            id: "e-circular-bcc",
                            required: _vm.bccString.trim(),
                          },
                          domProps: { value: _vm.bccString },
                          on: {
                            change: function (event) {
                              return _vm.updateBcc(event.target.value)
                            },
                          },
                        }),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "e-circular-resend-group",
                  attrs: { id: "eCircularResendGroup" },
                },
                [
                  _vm.previewType === _vm.PREVIEW_TYPES.RESEND
                    ? [
                        _c(
                          "div",
                          { staticClass: "basic-item e-circular-to-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "basic-item__label",
                                attrs: { for: "e-circular-to" },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("to")) +
                                    ":\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.resendTo,
                                  expression: "resendTo",
                                },
                                { name: "hkldinput", rawName: "v-hkldinput" },
                                { name: "autosize", rawName: "v-autosize" },
                                {
                                  name: "fusioninputcheck",
                                  rawName: "v-fusioninputcheck",
                                  value: {
                                    type: "string",
                                    tip: _vm.invalidEmailTip,
                                    pattern: _vm.validateEmails,
                                    classes: "tooltip-class",
                                    required: true,
                                  },
                                  expression:
                                    "{\n                  type: 'string',\n                  tip: invalidEmailTip,\n                  pattern: validateEmails,\n                  classes: 'tooltip-class',\n                  required: true\n                }",
                                },
                              ],
                              staticClass:
                                "autosize basic-item__value basic-item__value--input",
                              attrs: { id: "e-circular-to", required: true },
                              domProps: { value: _vm.resendTo },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.resendTo = $event.target.value
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "basic-item e-circular-bcc-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "basic-item__label",
                                attrs: { for: "e-circular-bcc" },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("bcc")) +
                                    ":\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.resendBcc,
                                  expression: "resendBcc",
                                },
                                { name: "hkldinput", rawName: "v-hkldinput" },
                                { name: "autosize", rawName: "v-autosize" },
                                {
                                  name: "fusioninputcheck",
                                  rawName: "v-fusioninputcheck",
                                  value: {
                                    type: "string",
                                    tip: _vm.invalidEmailTip,
                                    pattern: _vm.validateEmails,
                                    classes: "tooltip-class",
                                    required: _vm.resendBcc.trim(),
                                  },
                                  expression:
                                    "{\n                  type: 'string',\n                  tip: invalidEmailTip,\n                  pattern: validateEmails,\n                  classes: 'tooltip-class',\n                  required: resendBcc.trim()\n                }",
                                },
                              ],
                              staticClass:
                                "autosize basic-item__value basic-item__value--input",
                              attrs: {
                                id: "e-circular-bcc",
                                required: _vm.resendBcc.trim(),
                              },
                              domProps: { value: _vm.resendBcc },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.resendBcc = $event.target.value
                                },
                              },
                            }),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-item subject" }, [
                    _c("label", { staticClass: "basic-item__label" }, [
                      _vm._v(_vm._s(_vm.$t("eCircular.subject")) + ":"),
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        { name: "hkldinput", rawName: "v-hkldinput" },
                        { name: "autosize", rawName: "v-autosize" },
                        {
                          name: "fusioninputcheck",
                          rawName: "v-fusioninputcheck",
                          value: {
                            type: "string",
                            required: true,
                          },
                          expression:
                            "{\n                type: 'string',\n                required: true\n              }",
                        },
                      ],
                      staticClass:
                        "autosize basic-item__value basic-item__value--input",
                      domProps: { value: _vm.currentECircular.subject },
                      on: {
                        input: function ($event) {
                          return _vm.updateAttribute(
                            "subject",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "preview-ecircular__bk-line" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "preview-ecircular__content" },
              [_c("ECircularPreviewIndex")],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "preview-ecircular__bk-line" }),
            _vm._v(" "),
            _vm.ecircularDocs.length
              ? _c(
                  "div",
                  { staticClass: "preview-ecircular__attachments" },
                  [
                    _c("label", { staticClass: "attchments__label" }, [
                      _vm._v(_vm._s(_vm.$t("eCircular.attachments"))),
                    ]),
                    _vm._v(" "),
                    _c("EditAttachments", {
                      attrs: {
                        canEdit: false,
                        canDelete: false,
                        sourceId: _vm.currentECircular.id,
                        canDownloadAll: true,
                        zipName:
                          _vm.currentECircular.subject +
                          "_eCircular_Documents.zip",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.previewType === _vm.PREVIEW_TYPES.SEND
              ? _c(
                  "div",
                  { staticClass: "preview-ecircular__recipients" },
                  [
                    _c("label", { staticClass: "recipients__label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("eCircular.ecircularSentToTenants", [
                            _vm.isVendorEcircular
                              ? _vm.$t("eCircular.options.vendor").toLowerCase()
                              : _vm
                                  .$t("eCircular.options.tenant")
                                  .toLowerCase(),
                          ])
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("SelectRecipients", {
                      ref: "preview-recipients",
                      attrs: {
                        addedRecipients: _vm.addedRecipients,
                        operate: "VIEW",
                        showMarketingType: _vm.isMarketingECircular,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.previewType === _vm.PREVIEW_TYPES.SEND
            ? _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
                _c(
                  "button",
                  {
                    staticClass: "preview__send-test btn btn--darkblue",
                    on: {
                      click: function ($event) {
                        return _vm.openTestModal()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("action.testEmail")) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "preview__send-send btn btn--orange",
                    attrs: { disabled: !_vm.addedRecipientsCount },
                    on: {
                      click: function ($event) {
                        return _vm.openSendModal()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("action.send")) + "\n      "
                    ),
                  ]
                ),
              ])
            : _vm.previewType === _vm.PREVIEW_TYPES.RESEND
            ? _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
                _c(
                  "button",
                  {
                    staticClass: "preview__send-send btn btn--orange",
                    attrs: { disabled: !_vm.resendRecipientsCount },
                    on: {
                      click: function ($event) {
                        return _vm.resendECircular()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("action.resend")) +
                        "\n      "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "testEcircularModal",
          attrs: {
            "data-multiple-opened": "true",
            modalId: _vm.testModalId,
            beforeCloseModal: _vm.beforeCloseModal,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "test-ecircular e-circular-test-group",
              attrs: { slot: "content", id: "eCircularTestGroup" },
              slot: "content",
            },
            [
              _c("div", { staticClass: "test-ecircular__label" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("eCircular.inputTestEmail")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.testEmail,
                    expression: "testEmail",
                  },
                  { name: "hkldinput", rawName: "v-hkldinput" },
                  { name: "autosize", rawName: "v-autosize" },
                  {
                    name: "fusioninputcheck",
                    rawName: "v-fusioninputcheck",
                    value: {
                      type: "string",
                      tip: _vm.invalidEmailTip,
                      pattern: _vm.validateEmails,
                      classes: "tooltip-class",
                      required: true,
                    },
                    expression:
                      "{\n          type: 'string',\n          tip: invalidEmailTip,\n          pattern: validateEmails,\n          classes: 'tooltip-class',\n          required: true\n        }",
                  },
                ],
                staticClass: "autosize test-ecircular__input",
                attrs: { id: "e-circular-test", required: true },
                domProps: { value: _vm.testEmail },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.testEmail = $event.target.value
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                on: {
                  click: function ($event) {
                    return _vm.closeTestModal()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.cancel")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                on: {
                  click: function ($event) {
                    return _vm.testEcircular()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("action.sendTestEmail")) +
                    "\n      "
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.previewType === _vm.PREVIEW_TYPES.SEND
        ? _c(
            "modal",
            {
              ref: "sendEcircularModal",
              attrs: { modalId: _vm.sendModalId, modalType: "medium-modal" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "send-ecircular",
                  attrs: { slot: "content" },
                  slot: "content",
                },
                [
                  _c("div", { staticClass: "send-ecircular__label" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("eCircular.areYouSureToSend")) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "send-ecircular__hint count" }, [
                    _c("span", { staticClass: "count__number" }, [
                      _vm._v(_vm._s(_vm.addedRecipients.length)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "count__label count__label--organization",
                      },
                      [_vm._v(_vm._s(_vm.$t("eCircular.organizations")))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "count__number" }, [
                      _vm._v(_vm._s(_vm.addedRecipientsCount)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "count__label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("eCircular.recipientsWillReceiveThis"))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "send-ecircular__options" }, [
                    _c("div", { staticClass: "radio-item" }, [
                      _c("input", {
                        directives: [
                          { name: "hkldinput", rawName: "v-hkldinput" },
                        ],
                        staticClass: "radioClass",
                        attrs: {
                          id: _vm.sendNow,
                          name: "send-now",
                          type: "radio",
                        },
                        domProps: {
                          checked: _vm.sendOption === _vm.SEND_OPTIONS.SEND_NOW,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.updateSendOptionRadio(
                              _vm.SEND_OPTIONS.SEND_NOW
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "radio-label",
                          attrs: { for: _vm.sendNow },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("eCircular.sendNow")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "radio-item" }, [
                      _c("input", {
                        directives: [
                          { name: "hkldinput", rawName: "v-hkldinput" },
                        ],
                        staticClass: "radioClass",
                        attrs: {
                          id: _vm.sendAsScheduled,
                          name: "send-as-schedule",
                          type: "radio",
                        },
                        domProps: {
                          checked:
                            _vm.sendOption ===
                            _vm.SEND_OPTIONS.SEND_AS_SCHEDULE,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.updateSendOptionRadio(
                              _vm.SEND_OPTIONS.SEND_AS_SCHEDULE
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "radio-label",
                          attrs: { for: _vm.sendAsScheduled },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("eCircular.sendAsScheduleTime")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "send-ecircular__schedule" },
                    [
                      _c("label", { staticClass: "schedule-label" }, [
                        _vm._v(_vm._s(_vm.$t("eCircular.scheduleDateTime"))),
                      ]),
                      _vm._v(" "),
                      _c("DateTimeSelector", {
                        key: _vm.timestamp,
                        attrs: {
                          timeOptions: _vm.scheduleTimeOptions,
                          date: _vm.currentECircular.scheduleDate,
                          showClearBtn: true,
                          setMinTime: true,
                          disabledDates: { to: _vm.yesterday },
                          disabled:
                            _vm.sendOption !==
                            _vm.SEND_OPTIONS.SEND_AS_SCHEDULE,
                        },
                        on: {
                          updateDate: _vm.updateScheduleDate,
                          "update:partialSelected": _vm.updateTimeOptions,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn--darkblue",
                    on: {
                      click: function ($event) {
                        return _vm.closeSendModal()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("action.cancel")) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    attrs: { disabled: !_vm.isCanConfirmSend },
                    on: {
                      click: function ($event) {
                        return _vm.sendEcircular()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("action.yes")) + "\n      "
                    ),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "afterSendEcircularMoal",
          attrs: { modalId: _vm.sentModalId, modalType: "small-modal" },
        },
        [
          _c(
            "div",
            {
              staticClass: "ecircular-result",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _c("div", { staticClass: "ecircular-result__label" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.sendOption === _vm.SEND_OPTIONS.SEND_AS_SCHEDULE
                        ? _vm.$t("eCircular.ecircularScheduledSuccessfully")
                        : _vm.$t("eCircular.ecircularSentSuccessfully")
                    ) +
                    "\n      "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                on: {
                  click: function ($event) {
                    return _vm.closeAfterSendMoal()
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("action.ok")) + "\n      ")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }